import React, { useEffect, useRef, useState } from "react";
import CfLoader from "../CfLoader/CfLoader";
import { renderPdfToCanvas } from "../../utils/pdfUtils/renderPdfToCanvas";

const PdfPreview = React.memo(({ pdfUrl }) => {
  const canvasRef = useRef(null);
  const [isRendered, setIsRendered] = useState(false);
  const currentPdfRef = useRef(null);

  useEffect(() => {
    if (!pdfUrl || currentPdfRef.current === pdfUrl) {
      return;
    }

    currentPdfRef.current = pdfUrl;
    setIsRendered(false);

    const renderPdf = async () => {
      try {
        await renderPdfToCanvas(pdfUrl, canvasRef, () => {
          setIsRendered(true);
        });
      } catch (error) {
        console.error("PDF rendering failed:", error);
        setIsRendered(true);
      }
    };

    renderPdf();
  }, [pdfUrl]);

  return (
    <div className="flex justify-center w-full px-4 h-full overflow-auto object-contain">
      <canvas
        ref={canvasRef}
        className="w-auto max-w-full h-full"
        style={{ display: isRendered ? "block" : "none" }}
      />
      {!isRendered && (
        <div className="flex justify-center items-center w-full h-full">
          <CfLoader />
        </div>
      )}
    </div>
  );
});

PdfPreview.displayName = "PdfPreview";

export default PdfPreview;
